import { useState } from 'react';
import { notification } from 'antd';
import { ExportContactsParams } from '../contacts.types';
import { AxiosMediaUploadInstance } from '@/lib/axios/axios-media-upload-instance';
import { downloadBlobFile } from '@shared/utils/download-blob-file';
import { useTranslation } from 'react-i18next';

export const useExportContacts = () => {
  const [exportLoading, setExportLoading] = useState(false);
  const { t } = useTranslation();
  const exportContacts = async ({ selectedRowKeys, setSelectedRowKeys }: ExportContactsParams) => {
    try {
      setExportLoading(true);
      const idsQuery = selectedRowKeys.map((id) => `ids[]=${id}`).join('&');
      const exportUrl = `/providers/api/v1/contacts/export/{ids}?${idsQuery}`;
      const response = await AxiosMediaUploadInstance.post(exportUrl, null, {
        headers: { 'Content-Type': 'multipart/form-data' },
        responseType: 'blob',
      });
      const fetchLikeResponse = new Response(response?.data);
      await downloadBlobFile(Promise.resolve(fetchLikeResponse), {
        fileName: 'calilio_contacts.csv',
        onDownloadComplete: () => {
          setSelectedRowKeys([]);
          notification.success({ message: t('contacts_export_completed') });
        },
      });
    } catch (error) {
      console.error('Export error:', error);
      notification.error({ message: t('error_exporting_contacts_please_try_again') });
    } finally {
      setExportLoading(false);
    }
  };

  return {
    exportContacts,
    exportLoading,
  };
};
